import { Dialog } from '@headlessui/react';

export const ConfirmationDialog = ({showConfirmModal, updateUserStatus, setShowConfirmModal, pendingStatus, confirmStatusUpdate, isUpdating}) => (
    <div className={`modal-overlay ${showConfirmModal ? 'show' : ''}`}>
      <div className="modal-content">
        <h3>Confirm Status Change</h3>
        <p>Are you sure you want to {pendingStatus ? 'activate' : 'deactivate'} this user?</p>
        <div className="modal-buttons">
          <button 
            className="cancel-button"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </button>
          <button
            className="confirm-button"
            onClick={() => updateUserStatus(pendingStatus)}
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );